// extracted by mini-css-extract-plugin
module.exports = {"container":"Promo_container__yYW_4","messageWrapper":"Promo_messageWrapper__idtH7","inlineText":"Promo_inlineText__2ovyQ"};